<template>
  <div>
    <modals-container v-model="items" />

    <template>
      <mdb-container>
        <mdb-modal
          :show="confirmar"
          @close="confirmar = false"
          size="sm"
          class="text-center"
          style="top:40px;"
          danger
        >
          <mdb-modal-header center :close="false">
            <p
              class="heading"
            >Confirmar que quieres eliminar la Estrategia {{strategySelected.name}}</p>
          </mdb-modal-header>
          <mdb-modal-body>
            <mdb-icon icon="times" size="4x" class="animated rotateIn" />
          </mdb-modal-body>
          <mdb-modal-footer center>
            <mdb-btn outline="danger" @click="eliminar()">Si</mdb-btn>
            <mdb-btn color="danger" @click="confirmar = false">No</mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </mdb-container>
    </template>

    <template>
      <mdb-modal :show="modalCreate" @close="modalCreate = false" fullHeight info removeBackdrop>
        <mdb-modal-header center :close="false">
          <p class="heading lead">{{ modalName}}</p>
        </mdb-modal-header>
        <mdb-modal-body class="modal-body">
          <modal-create-strategy-action
            :onClick="closeModalCreate"
            v-if="modalName=='Crear acción estratégica'"
          ></modal-create-strategy-action>
          <modal-edit-strategy-action
            :onClick="closeModalCreate"
            :strategyAction="strategySelected"
            v-if="modalName=='Editar acción estratégica'"
          ></modal-edit-strategy-action>
        </mdb-modal-body>
        <mdb-modal-footer center>
          <mdb-btn outline="danger" @click="modalCreate = false">Cancelar</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>
    </template>

    <b-card>
      <b-btn variant="primary" class="p-2 mb-4" @click="createStrategy()">
        <i class="far fa-edit mr-1"></i>
        Nueva Estrategía
      </b-btn>
      <div slot="header" v-html="caption"></div>
      <b-table
        :dark="dark"
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        responsive="sm"
        :items="items"
        :fields="captions"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="acciones" slot-scope="data">
          <b-row>
            <div class="seleccionar col-3">
              <b-badge variant="primary" class="p-2" @click="selectStrategyEdit(data.item,items)">
                <i class="far fa-edit mr-1"></i>Editar
              </b-badge>
            </div>
            <div class="seleccionar col-2">
              <b-badge variant="danger" class="p-2" @click="selectStrategyDelete(data.item)">
                <i class="far fa-trash-alt mr-1"></i>Eliminar
              </b-badge>
            </div>
          </b-row>
        </template>

        <!--<template slot="status" slot-scope="data">
          <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
        </template>-->
      </b-table>
      <nav>
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        />
      </nav>
    </b-card>
  </div>
</template>

<script>
import ModalCreateStrategyAction from "../notifications/ModalCreateStrategyAction";
import ModalEditStrategyAction from "../notifications/ModalEditStrategyAction";
import store from "../../store";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";
export default {
  name: "table-partners",
  inheritAttrs: false,
  components: {
    ModalCreateStrategyAction,
    ModalEditStrategyAction,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  props: {
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1,
      modalCreate: false,
      strategySelected: {},
      modalName: "",
      confirmar: false
    };
  },
  computed: {
    items: function() {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    }
  },
  methods: {
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    closeModalCreate() {
      this.modalCreate = false;
    },
    getRowCount: function() {
      return this.items.length;
    },
    isTrueSelect(acciones) {
      if (acciones) {
        return true;
      }
      return false;
    },
    createStrategy() {
      this.modalName = "Crear acción estratégica";
      this.modalCreate = true;
    },
    selectStrategyEdit(item, items) {
      this.strategySelected = item;
      this.modalName = "Editar acción estratégica";
      this.modalCreate = true;
    },
    selectStrategyDelete(item) {
      this.partnerSelected = item;
      this.modalName = "Eliminar";
      this.confirmar = true;
    },
    eliminar() {
      setTimeout(()=>{
        store.dispatch("deleteStrategyActionsUtility",this.partnerSelected.id);
      },400)
      store.dispatch("deleteStretegyAction", this.partnerSelected.id);
      this.confirmar = false;
     
    }
  }
};
</script>

<style scoped>
.badge {
  cursor: pointer;
}
.modal-body {
  overflow-y: auto;
  height: 400px;
  padding-top: 100px !important;
}
</style>
